import React from 'react'

const Plus = ({ classname }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className={classname ? classname : 'size-5'}
	>
		<path
			d='M9.16666 10.8332H4.99999C4.76388 10.8332 4.5661 10.7532 4.40666 10.5932C4.24722 10.4332 4.16721 10.2354 4.16666 9.99984C4.1661 9.76428 4.2461 9.56651 4.40666 9.40651C4.56721 9.24651 4.76499 9.16651 4.99999 9.16651H9.16666V4.99984C9.16666 4.76373 9.24666 4.56595 9.40666 4.40651C9.56666 4.24706 9.76444 4.16706 9.99999 4.16651C10.2355 4.16595 10.4336 4.24595 10.5942 4.40651C10.7547 4.56706 10.8344 4.76484 10.8333 4.99984V9.16651H15C15.2361 9.16651 15.4342 9.24651 15.5942 9.40651C15.7542 9.56651 15.8339 9.76428 15.8333 9.99984C15.8328 10.2354 15.7528 10.4335 15.5933 10.594C15.4339 10.7546 15.2361 10.8343 15 10.8332H10.8333V14.9998C10.8333 15.236 10.7533 15.434 10.5933 15.594C10.4333 15.754 10.2355 15.8337 9.99999 15.8332C9.76444 15.8326 9.56666 15.7526 9.40666 15.5932C9.24666 15.4337 9.16666 15.236 9.16666 14.9998V10.8332Z'
			fill='currentColor'
		/>
	</svg>
)

export default Plus
